/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class s{constructor(){this._candidateTiles=[]}schedule(s){this._candidateTiles.includes(s)||this._candidateTiles.push(s)}reshuffle(s){const e=[];for(const i of this._candidateTiles)s>0?(i.reshuffle(),s--):e.push(i);this._candidateTiles=e}}export{s as TileReshuffleManager};
